import styled from "styled-components";
import { FlexContainer } from "styled/Box";

export const Marker = styled(FlexContainer)`
  width: 3rem;
  height: 3rem;
  position: relative;
  bottom: -10px;
`;
